import { useEffect, useState } from 'react';
import { ILogItem } from '../model';
import "./LogItem.scss"

interface ILogItemProps {
    log: ILogItem
}
const LogItem = ({ log }: ILogItemProps) => {
    const [isNew, setIsNew] = useState(true)
    useEffect(() => {
        setTimeout(() => {
            setIsNew(false)
        }, 1500)
    }, [])

    const getBgColor = () => {
        switch (log.status) {
            case "error":
                return "#ff3333"
            case "info":
                return "#CECCCC"
            case "success":
                return "#62E669"
            case "main":
                return "#62B1E6"
            default:
                return "#CECCCC"
        }
    }
    const getTextColor = () => {
        switch (log.status) {
            case "error":
                return "#660505"
            case "info":
                return "#2E2E2D"
            case "success":
                return "#0E5305"
            case "main":
                return "#054A53"
            default:
                return "#2E2E2D"
        }
    }

    return (
        <div
            className='log-item'
            style={{

                justifyContent: log.source === "server" ? "flex-start" : "flex-end"

            }}
        >
            <div
                className={`log-item__message ${isNew ? "new" : ""}`}
                style={{
                    color: getTextColor(),
                    backgroundColor: getBgColor()
                }}>
                <div
                    style={{
                        display: "flex",
                        fontWeight: 500,
                        justifyContent: log.source === "server" ? "flex-start" : "flex-end"
                    }}>
                    {log.source == "server" ? "Сервер" : "Котич"}
                </div>
                <div>
                    {log.text}
                </div>
            </div>
        </div>
    );
};

export default LogItem;